import { IComponentOptions, IController } from "angular";
import { GlobalSearchItemEnriched } from "@gtmhub/search";
import { SearchCollection } from "@webapp/search/models/search.models";

/**
 * @example <gh-search-item is-state-view="$ctrl.stateView"
 *  section-idx="$parent.$index"
 *  item-idx="$index"
 *  search-term="{{$ctrl.searchTerm}}"
 *  on-mouseenter="$ctrl.onItemHover($event, { hovered: true })"
 *  on-mouseleave="$ctrl.onItemHover($event, { hovered: false })"
 *  generate-href-link="$ctrl.generateRecentItemHrefLink(facetName, item)"
 *  on-search-item-selection="$ctrl.selectItem(facetName, item, {facetIdx: $parent.$index, itemIdx: $index})"
 *  on-component-init="$ctrl.updateIndicator({isSearchItemLoaded: true})"></gh-search-item>
 * Displays a single search item inside a facet of the global search.
 *
 * @param item specifies the current search / recent item : GlobalSearchItemEnriched<SearchCollectionType>;
 * @param isStateView indicates if the component is rendered as a state / in navigation : boolean;
 * @param sectionIdx specifies the index of the current facet in list of facets : number;
 * @param itemIdx specifies the index of the current item in current facet : number;
 * @param searchTerm specifies a search term : string;
 * @param onMouseenter specifies a callback to be executed on mouseenter : (params: { $event: MouseEvent }) => void;
 * @param onMouseleave specifies a callback to be executed on mouseleave: (params: { $event: MouseEvent }) => void;
 * @param generateHrefLink specifies a callback which will be executed on component init to generate a navigation link for interaction with the current item : () => string;
 * @param onSearchItemSelection specifies a callback which will be executed on click on the current item : () => void;
}
 */

interface IGlobalSearchItemBindings {
  item: GlobalSearchItemEnriched<SearchCollection>;
  isStateView: boolean;
  sectionIdx: number;
  itemIdx: number;
  searchTerm: string;
  onMouseenter(params: { $event: MouseEvent }): void;
  onMouseleave(params: { $event: MouseEvent }): void;
  generateHrefLink(): string;
  onSearchItemSelection(): void;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface GlobalSearchItemCtrl extends IGlobalSearchItemBindings {}
class GlobalSearchItemCtrl implements IController {
  public hrefLink: string;

  $onInit(): void {
    this.hrefLink = this.generateHrefLink();
  }
}

export const GlobalSearchItemComponent: IComponentOptions = {
  controller: GlobalSearchItemCtrl,
  template: require("./global-search-item.html"),
  bindings: {
    item: "<",
    isStateView: "<",
    sectionIdx: "<",
    itemIdx: "<",
    searchTerm: "@",
    generateHrefLink: "&",
    onMouseenter: "&",
    onMouseleave: "&",
    onSearchItemSelection: "&",
  },
};
